import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
    {
        path: '',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login.vue')
    },
    {
        path: '/home',
        name: '首页',
        component: () => import('@/views/home.vue'),
        meta: {
            icon: 'icon-shouye'
        },
    }
]

const router = new VueRouter({
    // mode: 'history',
    routes: routes
})

export default router
